import { gql } from "@apollo/client";

export const GET_CONTRATOS_RI_EV = gql`
query getContratosRIEV($filter: ContratoRIEVFilterInput!){
    contratosRIEV (filter: $filter) {    
        success,
        error,
        valorEsperado {
            idEvaluacion,
            contrato
        }
    }
  }
`;